<template>
  <div class="login">
	<div class="back-bg"></div>
	<div class="popup-overlay" id="popup-overlay" style="display: flex;">
		<div class="ageBox">
			<div class="cec-login">
				<div class="cec-logo">
					<img :src="this.CoreNew.WEB_URL+'images/login_logo.png'">
				</div>
				<div class="cec-logo-title">
					<h1>中电港移动办公平台</h1>
					<p>责任 创新 合作 诚信</p>
				</div>
			</div>
			<van-cell-group>
				<van-field
					v-model="user_name"
					left-icon="user-o"
					placeholder="请输入用户名"
				/>
				<van-field
				  		v-model="user_password"
				  		type="password"
						left-icon="eye-o"
				  		placeholder="请输入密码"
				/>
				<van-button type="primary" size="large" @click="onSubmit">登录</van-button>
			</van-cell-group>
		</div>
	</div>
  </div>
</template>
<script>
import axios from 'axios';
import secret  from '../../http/secret';
import { PcCookie, Key } from '../../http/cookie.js';
export default {
  async created() {
	    //15814445035
	    //oaportal
	    //D84B7641FB34C65498971A66E3B0DD0E
		//var keys = this.WDes.generatekey(16);
		//var encrypts = this.WDes.encryptDes("15814445035","oaportal");
		//var dess = JSON.parse(this.WDes.decryptDes("a12585d7cdbbf7915cfd4d3f170b0c06","oaportal"));
		//D84B7641FB34C65498971A66E3B0DD0E
  },
  mounted(){
  	var $rus=this.$router.history;
  	this.type=$rus["current"].query.type?$rus["current"].query.type:0;

	/**
	 * 	移动端切换用户
	 *
	 *	http://localhost:8082/login?type=1 能切换用户
	 *
	 *	切换用户 需要指定 const WEB_URL="http://10.2.22.43:8080"
	 *	http://10.2.22.43:8080/login?type=1
	 *	samuel.liu|5000009
	 *	wilson.jing|5002625
	 *	liqin.chen|5001315
	 *	desmond.wong|5002518
	 * 	may.huang|5000954
	 * */
	//if(this.type==1 && document.URL.indexOf("10.2.22") ==-1){
	if(this.type==1 && document.URL.indexOf("localhost") ==-1){
		this.$dialog.alert({
			message: '你无权限切换用户',
			showConfirmButton:false,
			overlayClass:"error-user"
		});
	}
  },
  data() {
    return {
	  type:0,//type=1切换用户
	  errors: [],
	  user_name: "",
	  user_password: "",
	  user_wxOpenid:localStorage.getItem('LS_WX_OPENID'),
	  user_wxUid:localStorage.getItem('LS_WX_UID'),
	  user_wxDeviceId:localStorage.getItem('LS_WX_DEVICEID')
    };
  },
  methods: {
	validPhone: function (phone) {
		var re = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})$/;
		return re.test(phone);
	},
	validEmail: function (email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	},
	createRandom: function (n) {
		let chars = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
		let res = "";
		for(let i = 0; i < n ; i ++) {
			 let id = Math.ceil(Math.random()*35); //10+24  因为Math.random()取不到1，所以需要往上+1,也许吧
			 res += chars[id];
		}
		return res;
	},
	onSubmit: function (e) {
		if(this.user_name == ''){
			this.$toast("用户名不能为空"); return false;
		}
		if(this.type==0 && this.user_password == ''){
			this.$toast("密码不能为空"); return false;
		}
		else{
			$("#loading").show();
			var WX_VUE_LOGIN=this;
			// submit
			let post_data = new FormData();
			if(this.type==0){
				post_data.append('username',this.user_name);
				var m = this.createRandom(2);
				var t = this.createRandom(2);

				//var _psw=Base64.encode(this.user_password.substr(0,2)+m+this.user_password.substr(2,(this.user_password.length-3))+t+this.user_password.substr((this.user_password.length-1),1));
				//post_data.append('password',this.user_password);
				var _psw = secret.cbcEnccrypt(this.user_password.trim());
				post_data.append('password',_psw);

				if(this.user_wxOpenid==null){
					post_data.append('wxOpenid',"");
				}else{
					post_data.append('wxOpenid',this.user_wxOpenid); //微信id
				}
				if(this.user_wxUid==null){
					post_data.append('wxUid',"");
				}else{
					post_data.append('wxUid',this.user_wxUid);  //企业微信id
				}
				if(this.user_wxDeviceId==null){
					post_data.append('deviceId',"");
				}else{
					post_data.append('deviceId',this.user_wxDeviceId); //设备
				}
				this.onLogin(post_data);//登录
			}else{  //切换用户
				var index = this.user_name.indexOf('|');
				var oid = this.user_name.substr((index+1),this.user_name.length - 1);
				var user_name=this.user_name.substr(0,index);

				post_data.append('username',user_name);
				post_data.append('password','');
				var WX_VUE=this;

				/* 切换用户----------------------------需要手动更新的值start */
				var _joaUserId=580;  //joa的userid
				var _token="Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mbyI6eyJkZXBhcnRtZW50TmFtZSI6IuS_oeaBr-S4reW_gyIsImNvZGUiOiI1MDAxMzE1IiwiZGVwYXJ0bWVudElkIjo0NTgsImZzc2NVcmwiOm51bGwsInd4dWlkIjoiNTAwMTMxNSIsImF1dGhvcml0aWVzIjpudWxsLCJlbmFibGVkIjoxLCJkdXR5TmFtZSI6IuaAu-ebkSIsIm1vYmlsZVBob25lIjoiMTM1MDI4MDAwNjMiLCJkdXR5TGV2ZWxOYW1lIjoiTTMiLCJqb2FEZXBhcnRtZW50SWQiOjExOTksImltYWdlVXJsIjoiaHR0cHM6Ly9wb3J0YWwuY2VjcG9ydC5jb20vaW1hZ2VzL3VzZXIvNTAwMTMxNS5qcGciLCJuYW1lIjoi6ZmI5Li955C0IiwiZGVwdENlbnRlck5hbWUiOiLkv6Hmga_kuK3lv4Mi…hwIjoxNjI2NzMyMDE3LCJ1c2VyX25hbWUiOiJsaXFpbi5jaGVuIiwianRpIjoiNjc1ZWVkZGQtNzhlYy00ZmM1LTliMjEtNzUwZGI0YmI1MTNhIiwiY2xpZW50X2lkIjoic2Fhcy1hZG1pbiIsInNjb3BlIjpbImFsbCJdfQ.Nq2zVR-3wHsMGj_PPDFlsqaj-i38Ehf2uOaS7doCnpg5tGHZbsDJ9jTqb2aQv_69yLt98Gn3TECpvbrgxcvz2exA36BsqbqxJIK8YLUAgPILGIFo4OmR0Wi0g1y3WdiukT3yw9k5JyQyjuXBww5Z7A7sXnRkCKg8IdRC9g0QUW430NER1X1hVxLkXY5dap7xzUNEGjWiwTJUBjyF6KrA_bGkfpajUchoSb-DlI3zJQDxcgzIovvmvwRd3g1HEDaH6tXD6L0tf8UNlL59NZOkNsUiIOn_OYqUKIj9AG1vr9a-4UddkNs8XfXEZpGiGoVH7kePaXeKb8DKHx6vwoCN0g";

				/* 切换用户----------------------------需要手动更新的值end */

				$.ajax({
					url:WX_VUE.CoreNew.NEW_OA_API_URL+"joa-business/auth/wxSimpleUser?wxUid="+oid,
					type:"get",
					async:false,
					beforeSend: function (XMLHttpRequest) {
						XMLHttpRequest.setRequestHeader('Authorization',_token);
					},
					success:function(response){
						var $rs=response.data;
						if(response.flag==true){
							WX_VUE.onLoginNew($rs,_token,_joaUserId);//登录信息
						}
					},
				})
				/*$.ajax({
					url:WX_VUE.CoreNew.OA_API_IP+"joa-business/auth/wxSimpleUser?wxUid="+oid,
					type:"get",
					dataType:"json",
					success:function(response){
						var $rs=response.data;
						if(response.flag==true){
							if($rs.wxOpenid==null){
								post_data.append('wxOpenid',''); //微信id
							}else{
								post_data.append('wxOpenid',$rs.wxOpenid); //微信id
							}
							if($rs.wxUid==null){
								post_data.append('wxUid',''); //企业微信id
							}else{
								post_data.append('wxUid',$rs.wxUid);  //企业微信id
							}
							if($rs.deviceId==null){
								post_data.append('deviceId',''); //设备
							}else{
								post_data.append('deviceId',$rs.deviceId); //设备
							}

							//WX_VUE.onLogin(post_data);//登录
							WX_VUE.onLoginNew(post_data);//登录
						}
					},
				})*/
			}
		}
	},
	onLoginNew: function ($rs,_token,_joaUserId) {
				//12小时失效---------新oa token
				let expirseTime=parseInt(new Date().getTime()/1000)+43199;
				let data ={value:"qie-huan-users",expirse:expirseTime};
				localStorage.setItem("QWXCODE", JSON.stringify(data));
				
				//this.CoreNew.ADMIN.USER_NEWOA_ID=$rs.id;
				this.CoreNew.ADMIN.USER_NEWOA_ID="";
				this.CoreNew.ADMIN.USER_ID=_joaUserId;

				this.CoreNew.ADMIN.USER_CODE=$rs.code;
				this.CoreNew.ADMIN.USER_ACCOUNT=$rs.username;
				this.CoreNew.ADMIN.USER_NAME=$rs.name;
				this.CoreNew.ADMIN.USER_PHONE=$rs.mobile;
				this.CoreNew.ADMIN.USER_EMAIL=$rs.email;
				this.CoreNew.ADMIN.USER_IMAGE=$rs.pic;
				this.CoreNew.ADMIN.USER_AUTHORIZATION=_token;
				this.CoreNew.ADMIN.USER_DEPARTMENT_ID=$rs.departmentId;
				this.CoreNew.ADMIN.USER_DEPARTMENT_NAME=$rs.departmentName;
				this.CoreNew.ADMIN.USER_LEVEL_NAME=$rs.dutyLevelName;
				this.CoreNew.ADMIN.DUTY_NAME=$rs.dutyName;
				this.CoreNew.QWX_ID=$rs.wxUid;
				this.CoreNew.QWX_DEVICEID=$rs.deviceId;

				localStorage.setItem('LS_ADMIN', JSON.stringify(this.CoreNew.ADMIN));
				localStorage.setItem('LS_QWX_DEVICEID', JSON.stringify($rs.deviceId));
				localStorage.setItem('LS_QWX_WxUid', JSON.stringify($rs.wxUid));
				localStorage.setItem('LS_QWX_WxOpenid', JSON.stringify($rs.wxOpenid));
				localStorage.setItem('LS_ADMIN_USER_ID', JSON.stringify($rs.id));
				localStorage.setItem('LS_ADMIN_USER_NAME', JSON.stringify($rs.username));
				localStorage.setItem('LS_ADMIN_USER_IMAGE', JSON.stringify($rs.pic));
				localStorage.setItem('LS_ADMIN_USER_AUTHORIZATION', JSON.stringify(_token));
				localStorage.setItem('LS_FSSC_LOFIN_URL', $rs.fsscUrl);
				console.log($rs);
				$.ajax({
					url:$rs.fsscUrl,
					type:"GET",
					dataType:"jsonp",
					jsonp:"jsonpcallback",
					success:function(res){
						$("#loading").hide();
						if( localStorage.getItem('LS_BACK_URL') == null){
							window.location.href=JSON.parse(localStorage.getItem('LS_WEB_URL'))+'reports/';
						}else{
							window.location.href=localStorage.getItem('LS_BACK_URL');
						}
					},
					error:function(){
						$("#loading").hide();
						if( localStorage.getItem('LS_BACK_URL') == null){
							window.location.href=JSON.parse(localStorage.getItem('LS_WEB_URL'))+'reports/';
						}else{
							window.location.href=localStorage.getItem('LS_BACK_URL');
						}
					}
				});
	},
	// 根据cookie去登录
	getCookieOALogin(oAToken) {
		var WX_VUE=this;
		let loginUrl = WX_VUE.CoreNew.NEW_OA_API_URL+"api/system/sys-user/getLoginUserForJOA";
		$.ajax({
			url:loginUrl,
			type:"post",
			async:false,
			beforeSend: function (XMLHttpRequest) {
				XMLHttpRequest.setRequestHeader('Authorization','Bearer '+oAToken);
			},
			success:function(response){
				var res=response;
				if(res.code==200){
					//用户信息
					var $rs=res.data.userInfo;
		
					WX_VUE.CoreNew.ADMIN.USER_NEWOA_ID=$rs.id;
					WX_VUE.CoreNew.ADMIN.USER_ID=$rs.joaId;
					WX_VUE.CoreNew.ADMIN.USER_CODE=$rs.code;
					WX_VUE.CoreNew.ADMIN.USER_ACCOUNT=$rs.username;
					WX_VUE.CoreNew.ADMIN.USER_NAME=$rs.name;
					WX_VUE.CoreNew.ADMIN.USER_PHONE=$rs.mobilePhone;
					WX_VUE.CoreNew.ADMIN.USER_EMAIL=$rs.email;
					WX_VUE.CoreNew.ADMIN.USER_IMAGE=$rs.imageUrl;
					WX_VUE.CoreNew.ADMIN.USER_AUTHORIZATION="Bearer "+oAToken;
					WX_VUE.CoreNew.ADMIN.USER_NEW_DEPARTMENT_ID=$rs.departmentId;//新oa的departmentId
					WX_VUE.CoreNew.ADMIN.USER_DEPARTMENT_ID=$rs.joaDepartmentId;//joa的departmentId
					WX_VUE.CoreNew.ADMIN.USER_DEPARTMENT_NAME=$rs.departmentName;
					WX_VUE.CoreNew.ADMIN.USER_LEVEL_NAME=$rs.dutyLevelName;
					WX_VUE.CoreNew.ADMIN.DUTY_NAME=$rs.dutyName;
					WX_VUE.CoreNew.QWX_ID=$rs.wxUid;
					WX_VUE.CoreNew.QWX_DEVICEID=$rs.deviceId;
					localStorage.setItem('LS_ADMIN', JSON.stringify(WX_VUE.CoreNew.ADMIN));
					localStorage.setItem('LS_QWX_DEVICEID', JSON.stringify($rs.deviceId));
					
					localStorage.setItem('LS_ADMIN_USER_ID', JSON.stringify($rs.id));
					localStorage.setItem('LS_ADMIN_USER_NAME', JSON.stringify($rs.username));
					localStorage.setItem('LS_ADMIN_USER_IMAGE', JSON.stringify($rs.imageUrl));
					localStorage.setItem('LS_ADMIN_USER_AUTHORIZATION', JSON.stringify("Bearer "+oAToken));
					localStorage.setItem('LS_ADMIN_USER_AUTHORIZATION_NOBEARER', oAToken);
					localStorage.setItem('LS_FSSC_LOFIN_URL', $rs.fsscUrl);
					console.log($rs);
					$.ajax({
						url:$rs.fsscUrl,
						type:"GET",
						dataType:"jsonp",
						jsonp:"jsonpcallback",
						success:function(res){
							$("#loading").hide();
							if( localStorage.getItem('LS_BACK_URL') == null){
								window.location.href=JSON.parse(localStorage.getItem('LS_WEB_URL'))+'reports/';
							}else{
								window.location.href=localStorage.getItem('LS_BACK_URL');
							}
						},
						error:function(){
							$("#loading").hide();
							if( localStorage.getItem('LS_BACK_URL') == null){
								window.location.href=JSON.parse(localStorage.getItem('LS_WEB_URL'))+'reports/';
							}else{
								window.location.href=localStorage.getItem('LS_BACK_URL');
							}
						}
					});
				}else{
					if(res.code==401){ //身份已过期
						localStorage.setItem('LS_NOLOGIN_STATUS', "no");
						WX_VUE.$toast.setDefaultOptions({ duration: 3000});
						WX_VUE.$toast('身份已过期，请重新登录');
						this.$router.push("/login/")
					}else{
						localStorage.setItem('LS_NOLOGIN_STATUS', "no");
						WX_VUE.$dialog.alert({
							message: res.message,
							showConfirmButton:false,
							overlayClass:"error-user"
						});
					}
				}
			},
			error:function(error){
				localStorage.setItem('LS_NOLOGIN_STATUS', "no");
				WX_VUE.$dialog.alert({
					message: "维护中，稍后再试",
					showConfirmButton:false,
					overlayClass:"error-user"
				});
				console.log(error);
				WX_VUE.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--新系统登录--失败"+error);//记录错误
				console.log("请求--DM,SAAS系统登录--失败"+error);
			}
		})
	},
	onLogin: function (post_data) {
		// 请求头添加 Authorization: Basic client_id:client_secret
		const authconfig = {
		  username: 'saas-admin',
		  password: 'cliSecret10_YB!*('
		}
		const str = authconfig.username + ':' + authconfig.password;
		const pa = Base64.toBase64(str);
		const auth = `Basic ` + pa;
		const headers = {
		  'Content-Type': 'application/x-www-form-urlencoded',
		  'Authorization': auth
		}
		post_data.append('imagesFlag', 'N');
		post_data.append('clientId', 'ThSsCMPERXpfTqAUESAovQ==');
		post_data.append('clientSecret', 'X21KYpdhC4p5Yt+GMEStoGidXm+mhjgQujUkNw/umBc=');
		axios.post(this.CoreNew.OA_API_IP+"api/auth/login",post_data,{
			headers: headers,
			timeout: 6000
		}).then(function (response) {
			var $rs=response.data;
			if($rs.code==200){
				// 设置cookies
				const access_token = $rs.data.access_token;
				this.getCookieOALogin($rs.data.access_token);
				//PcCookie.set(Key.accessTokenKey, access_token)
				/*this.CoreNew.ADMIN.USER_NEWOA_ID=$rs.userInfo["id"];
				this.CoreNew.ADMIN.USER_ID=$rs.userInfo["joaId"];
				this.CoreNew.ADMIN.USER_CODE=$rs.userInfo["code"];
				this.CoreNew.ADMIN.USER_ACCOUNT=$rs.userInfo["username"];
				this.CoreNew.ADMIN.USER_NAME=$rs.userInfo["name"];
				this.CoreNew.ADMIN.USER_PHONE=$rs.userInfo["mobilePhone"];
				this.CoreNew.ADMIN.USER_EMAIL=$rs.userInfo["email"];
				this.CoreNew.ADMIN.USER_IMAGE=$rs.userInfo["imageUrl"];
				this.CoreNew.ADMIN.USER_AUTHORIZATION="Bearer "+$rs.data.access_token;
				this.CoreNew.ADMIN.USER_DEPARTMENT_ID=$rs.userInfo["departmentId"];
				this.CoreNew.ADMIN.USER_DEPARTMENT_NAME=$rs.userInfo["departmentName"];
				this.CoreNew.ADMIN.USER_LEVEL_NAME=$rs.userInfo["dutyLevelName"];
				this.CoreNew.ADMIN.DUTY_NAME=$rs.userInfo["dutyName"];
				this.CoreNew.QWX_ID=$rs.userInfo["wxuid"];
				this.CoreNew.QWX_DEVICEID=$rs.userInfo["deviceId"];

				localStorage.setItem('LS_ADMIN', JSON.stringify(this.CoreNew.ADMIN));
				localStorage.setItem('LS_QWX_DEVICEID', JSON.stringify($rs.userInfo["deviceId"]));
				//wxUid,wxOpenid
				localStorage.setItem('LS_QWX_WxUid', JSON.stringify($rs.userInfo["wxUid"]));
				localStorage.setItem('LS_QWX_WxOpenid', JSON.stringify($rs.userInfo["wxOpenid"]));
				localStorage.setItem('LS_ADMIN_USER_ID', JSON.stringify($rs.userInfo["id"]));
				localStorage.setItem('LS_ADMIN_USER_NAME', JSON.stringify($rs.userInfo["username"]));
				localStorage.setItem('LS_ADMIN_USER_IMAGE', JSON.stringify($rs.userInfo["pic"]));
				localStorage.setItem('LS_ADMIN_USER_AUTHORIZATION', JSON.stringify("Bearer "+$rs.data.access_token));
				localStorage.setItem('LS_FSSC_LOFIN_URL', $rs.userInfo["fsscUrl"]);
				console.log($rs);
				
				$.ajax({
					url:$rs.userInfo["fsscUrl"],
					type:"GET",
					dataType:"jsonp",
					jsonp:"jsonpcallback",
					success:function(res){
						$("#loading").hide();
						if( localStorage.getItem('LS_BACK_URL') == null){
							window.location.href=JSON.parse(localStorage.getItem('LS_WEB_URL'))+'reports/';
						}else{
							window.location.href=localStorage.getItem('LS_BACK_URL');
						}
					},
					error:function(){
						$("#loading").hide();
						if( localStorage.getItem('LS_BACK_URL') == null){
							window.location.href=JSON.parse(localStorage.getItem('LS_WEB_URL'))+'reports/';
						}else{
							window.location.href=localStorage.getItem('LS_BACK_URL');
						}
					}
				});*/
			}else{
				//this.$toast.setDefaultOptions({ duration: 3000000,closeOnClick :true });
				this.$toast.setDefaultOptions({ duration: 3000});
				this.$toast(response.data.message);
				$("#loading").hide();
			}
		}.bind(this)).catch(function (error) {
			$("#loading").hide();
			this.$toast("用户名或密码错误");
		});
		e.preventDefault();
	},
    sorry() {
      Toast('暂无后续逻辑~');
    }
  }
};
</script>
